// src/pages/index.js
import React, { useEffect, useState } from 'react';
import Header from '../component/Header';
import Footer from '../component/Footer';
import Slider from "react-slick";
import axios from 'axios';
function Vehicle() {
    const [brands, setBrand] = useState([])
    const [bodys, setBody] = useState([])
    const [vehicles, setVehicle] = useState([])
    const [price, setPrice] = useState(10000);
    const [brandId, setBrandId] = useState(null);
    const [bodyId, setBodyId] = useState(null);
    const [minPrice, setMinPrice] = useState('1000');
    const [maxPrice, setMaxPrice] = useState(null);

    const baseUrl = process.env.REACT_APP_API_BASE_URL;


  useEffect(() => {

    vehicleList();
   
  }, []);


  const vehicleList = () => {
    const filterData = {};
  
    if (brandId) filterData.brand = brandId;
    if (bodyId) filterData.body = bodyId;
    if (minPrice) filterData.min_price = minPrice;
    if (maxPrice) filterData.max_price = maxPrice;
  
    const hasFilters = Object.keys(filterData).length > 0;
  
    axios
      .post(`${baseUrl}/vehicles`, hasFilters ? filterData : {})
      .then((response) => {
        setVehicle(response.data['VEHICLES']);
        console.log(response.data['VEHICLES']);
      })
      .catch((error) => {
        console.error('Failed to fetch vehicles:', error);
      });
  };
  
  
  useEffect(() => {
    axios
      .get(`${baseUrl}/brands`)
      .then((response) => {
        setBrand(response.data['brands']);
      })
      .catch((error) => {
        console.error('Failed to fetch brands:', error);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${baseUrl}/bodys`)
      .then((response) => {
        setBody(response.data['bodys']);
      })
      .catch((error) => {
        console.error('Failed to fetch brands:', error);
      });
  }, []);

  return (

      <>
      
      <Header />
  <div
    className="overflow-hidden space"
    id="contact-sec"
    style={{ backgroundImage: "url('/assets/img/bg/contact_bg_7.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center center" }}>
  
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <form className="contact-form2 ajax-contact">
            <div className="row">
              <div className="col-6">
                <span>RS:1000</span>
              </div>
              <div className="col-6 text-end">
                RS: <span id="priceValue">{maxPrice}</span>
              </div>
              <div className="col-lg-12">
                <input  type="range" id="priceRange" name="priceRange"  min={1000} max={150000} step={1000} defaultValue={50000} value={maxPrice}
        onChange={(e) => setMaxPrice(e.target.value)}/>
              </div>
              <div className="col-lg-6 mt-4">
                <div className="form-group">
                  <select className="form-control" onChange={(e)=>setBrandId(e.target.value)}>
                  <option value="">All</option>
                    {vehicles && vehicles.length > 0 ? (
                      brands.map((brand, index) =>(
                      <option value={brand.id}>{brand.brand_name}</option>

                    ))
                  ):(
                    <option value="">Select Brand</option>
                  )}
                  </select>
                </div>
              </div>
              <div className="col-lg-6 mt-4">
                <div className="form-group">
                <select className="form-control" onChange={(e)=>setBodyId(e.target.value)}>
                <option value="">All</option>
                    {bodys && bodys.length > 0 ? (
                      bodys.map((body, index) =>(
                      <option value={body.id}>{body.body_name}</option>

                    ))
                  ):(
                    <option value="">Select Body</option>
                  )}
                  </select>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="form-btn">
                  <a className="th-btn style-radius text-capitalize w-100" onClick={vehicleList}>
                    Filter
                  </a>
                </div>
              </div>
              <p className="form-messages mb-0 mt-3" />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <section className="service-sec15 space" id="service-sec">
    <div className="container th-container4">
      <div className="row justify-content-center">

          {vehicles && vehicles.length > 0 ? (
                vehicles.map((vehicle, index) => (
               
                <div className="col-lg-4 col-md-6 col-sm-6 px-xl-4 mt-5"  key={index}>
                    <div className="blog-box2 style2 card m-2">
                      <div className="mb-3 d-flex align-items-center justify-content-center" >
                        <img className="" width={300} src={vehicle.vehicle_image || "assets/img/loading/carLoading.gif"} alt="Image" />
                      </div>
                      <div className="row">
                        <div className="col-xl-9 col-md-9 col-sm-9 col-9">
                          <h3 className="box-title mb-0">
                            {vehicle.brand || 'Waiting...'}
                          </h3>
                          <span><b>{vehicle.model || 'Waiting...'}</b></span>
                        </div>
                        <div className="col-xl-3 col-md-3 col-sm-3 col-3">
                          <h6>
                            {vehicle.rating || '0'}{" "}
                            <i className="fa-sharp fa-solid fa-star text-warning" width="20px" />
                          </h6>
                        </div>
                      </div>
                      <div className="cilent-box">
                        <div className="about_review">
                          <i className="fa-sharp fa-solid fa-user text-primary" />
                          <span className="text-dark">{vehicle.no_of_seat || '0'}</span> &nbsp;&nbsp;&nbsp;
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={20} height={20} fill="#0d6efd">
                            <path d="M4 22h16c1.1 0 2-.9 2-2V9.83c0-.53-.21-1.04-.59-1.41L14.59 2.59C14.21 2.21 13.7 2 13.17 2H8c-1.1 0-2 .9-2 2v4H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2zM8 4h5.17l6 6H8V4zm0 14H6v-2h2v2zm10 0H10v-2h8v2z" />
                          </svg>
                          <span className="text-dark">{vehicle.no_of_door || '0'}</span>&nbsp;&nbsp;&nbsp;
                          <i className="fa-sharp fa fa-shopping-bag text-primary" />
                          <span className="text-dark">{vehicle.no_of_door || '0'}</span>&nbsp;&nbsp;&nbsp;
                          <i className="fa-sharp fa-solid fa fa-car text-primary" />
                          <span className="text-dark"> {vehicle.body || '0'}</span>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-xl-6 col-md-6 col-sm-6 col-6">
                          <h6>
                            Rs {vehicle.price || '0'} <span>/Days</span>
                          </h6>
                        </div>
                        <div className="col-xl-6 col-md-6 col-sm-6 col-6 text-end">
                          <a href={"/vehcile-details?id="+vehicle.id} className="th-btn style-radius text-capitalize">
                            View
                          </a>
                        </div>
                      </div>
                    </div>
                </div>
                ))
              ) : (
                  <h4>Data Not Found</h4>
              )}

      </div>
    </div>
  </section>


      <Footer />

    </>

  );
}

export default Vehicle;
